import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';

// Asset Imports
import logo from './assets/kabadayigames-transparent.png';
import ballgorithmIcon from './assets/ballgoritm_icon.png';
import paper2quizIcon from './assets/paper2quiz_icon.png';
import monogramTransparent from './assets/monogram-transparent.png';
import iconTransparent from './assets/icon-transparent.png';

// Privacy Policy page import
import PrivacyPolicy from './PirvacyPolice';

function Home() {
  React.useEffect(() => {
    const link = document.querySelector("link[rel~='icon']");
    if (link) {
      link.href = monogramTransparent;
    }
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="app-container">
      {/* Header */}
      <header className="main-header">
        <Link to="/" className="logo-section">
          <img src={iconTransparent} alt="Kabadayı Games Hand Gesture Logo" className="logo-img" style={{ objectFit: 'contain' }} />
          <h1 className="logo-title">Kabadayı Games</h1>
        </Link>
        <nav className="nav-links">
          <button onClick={() => scrollToSection('games')} className="nav-link" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>Ürünlerimiz</button>
          <button onClick={() => scrollToSection('philosophy')} className="nav-link" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>Felsefemiz</button>
          <button onClick={() => scrollToSection('about')} className="nav-link" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>Hakkımızda</button>
          <Link to="/privacy-policy" className="nav-link">Gizlilik</Link>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="hero-section">
        <span className="hero-badge">Games & Study Apps</span>
        <h2 className="hero-title">Handcrafted Games with Heart.</h2>
        <p className="hero-subtitle">
          Biz büyük bütçeli ve gösterişli ürünler yerine; küçük ama unutulmaz deneyimler,
          el çizimi sanat anlayışı ve oyuncunun / öğrencinin yüzünde tebessüm bırakan
          deneyimler üretiriz — oyunlardan AI destekli çalışma uygulamalarına.
        </p>
        <button onClick={() => scrollToSection('games')} className="cta-button">
          Ürünlerimizi Keşfet ➔
        </button>
      </section>

      {/* Main Content */}
      <main className="main-content">
        
        {/* Games & Apps Section */}
        <section id="games" style={{ scrollMarginTop: '2rem' }}>
          <h2 className="section-title">Oyunlar & Uygulamalar</h2>
          
          <div className="game-showcase-card">
            <div className="game-media-container">
              <div className="game-icon-frame">
                <img src={ballgorithmIcon} alt="Ballgorithm Icon" className="game-icon" />
              </div>
            </div>
            
            <div className="game-details">
              <span className="game-tag">Fizik Bulmaca</span>
              <h3 className="game-title">Ballgorithm</h3>
              <p className="game-description">
                Ballgorithm, golf mekaniklerinden ve 2048 tarzı birleştirme bulmacalarından ilham alan, 
                fizik tabanlı ve akıllıca tasarlanmış bir bulmaca oyunudur. Topları doğru açıyla fırlatın, 
                engelleri aşın ve hedefe ulaşın!
              </p>
              
              <ul className="game-features-list">
                <li>El emeği hissi veren seviye tasarımları</li>
                <li>Huzur veren, kafa yormayan pastel atmosfer</li>
                <li>Eğlenceli ve tahmin edilemez fizik tabanlı mekanikler</li>
                <li>Hem dinlendirici hem de zeka zorlayıcı bulmacalar</li>
              </ul>
              
              <div className="download-buttons">
                <a 
                  href="https://play.google.com/store/apps/details?id=com.kabadayigames.ballgorithm" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="cta-button"
                  style={{ fontSize: '1.05rem', padding: '0.7rem 1.5rem' }}
                >
                  Google Play'de İndir
                </a>
              </div>
            </div>
          </div>

          <div className="game-showcase-card paper2quiz-card">
            <div className="game-media-container">
              <div className="game-icon-frame paper2quiz-icon-frame">
                <img src={paper2quizIcon} alt="Paper2Quiz Icon" className="game-icon" />
              </div>
            </div>

            <div className="game-details">
              <span className="game-tag" style={{ backgroundColor: 'var(--soft-peach)' }}>AI Çalışma Uygulaması</span>
              <h3 className="game-title">Paper2Quiz</h3>
              <p className="game-description">
                Paper2Quiz, sınav PDF&apos;lerini interaktif quiz&apos;lere, flashcard&apos;lara ve
                adım adım AI öğretmen oturumlarına dönüştürür. Konu yaz → öğrenme ağacı çıkar →
                kavram kartlarıyla pekiştir → quiz ile ölç. Verilerin büyük kısmı cihazında kalır;
                AI için kendi Gemini API anahtarını kullanırsın.
              </p>

              <ul className="game-features-list">
                <li>PDF&apos;den soru bankası ve quiz oturumları</li>
                <li>AI Teacher: müfredat haritası, anlatım, pratik, quiz</li>
                <li>Öğrenme Merkezi — spaced repetition flashcard&apos;lar</li>
                <li>Yanlışlar, mastery takibi ve yerel ders kitapların</li>
              </ul>

              <div className="download-buttons" style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
                <a
                  href="https://play.google.com/store/apps/details?id=com.kabadayigames.papertwoquiz"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cta-button"
                  style={{ fontSize: '1.05rem', padding: '0.7rem 1.5rem' }}
                >
                  Google Play&apos;de İndir
                </a>
                <a
                  href="https://kabadayigames.github.io/paper2quiz-privacy.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cta-button secondary-cta"
                  style={{ fontSize: '1.05rem', padding: '0.7rem 1.5rem' }}
                >
                  Gizlilik Politikası
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Philosophy & About Section */}
        <section id="philosophy" style={{ scrollMarginTop: '2rem' }}>
          <div className="philosophy-grid">
            
            {/* Philosophy Card */}
            <div className="info-card" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div>
                <h3>Biz Kimiz?</h3>
                <p>
                  Kabadayı Games, oyunların sadece kod yığınından ibaret olmadığına inanır. 
                  Her oyunumuz bir defter sayfasına çizilmiş gibi hissettirmelidir. 
                  Görsel dilimizde neon ışıklara, cyber temalara veya agresif ögelere yer yoktur. 
                  Biz pastel tonların sıcaklığını, kağıt dokusunun doğallığını ve lo-fi melodilerin sakinliğini tercih ederiz.
                </p>
                <p style={{ marginTop: '1rem', fontStyle: 'italic', color: 'var(--primary-purple)', fontWeight: 'bold' }}>
                  "We don't build games. We handcraft little moments of joy."
                </p>
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1.5rem' }}>
                <img src={iconTransparent} alt="Kabadayı Games Hand Gesture" style={{ width: '50px', height: '50px', opacity: 0.8, objectFit: 'contain' }} />
              </div>
            </div>

            {/* About Card */}
            <div id="about" className="info-card" style={{ scrollMarginTop: '2rem' }}>
              <h3>Geliştirici & Girişimci</h3>
              <p>
                Merhaba! Ben Resul Çalışkan. Kabadayı Games'in kurucusu ve tek geliştiricisiyim. 
                Mobil uygulamalar, oyunlar ve yapay zeka alanında projeler üretmeyi, aklıma gelen fikirleri 
                gerçeğe dönüştürmeyi çok seviyorum. Benim için her proje, yeni bir öğrenme ve yaratıcılık serüvenidir.
              </p>
              
              <div className="about-avatar-container">
                <img src={monogramTransparent} alt="Resul Çalışkan Monogram" className="about-avatar" style={{ objectFit: 'contain', padding: '8px', backgroundColor: 'var(--lavender)' }} />
                <div className="avatar-info">
                  <h4>Resul Çalışkan</h4>
                  <p>Kabadayı Games Kurucusu</p>
                </div>
              </div>
            </div>

          </div>
        </section>

      </main>

      {/* Footer */}
      <footer className="main-footer">
        <div className="footer-content">
          <div className="footer-logo">Kabadayı Games</div>
          
          <div className="footer-nav">
            <button onClick={() => scrollToSection('games')} className="footer-nav-link" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>Ürünler</button>
            <button onClick={() => scrollToSection('philosophy')} className="footer-nav-link" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>Felsefe</button>
            <Link to="/privacy-policy" className="footer-nav-link">Gizlilik Politikası</Link>
          </div>

          <div className="footer-socials">
            <a href="mailto:resulcaliskansau@gmail.com" className="social-button">📧 E-Posta</a>
            <a href="https://www.youtube.com/@KabadayiGamesStudio" target="_blank" rel="noopener noreferrer" className="social-button">🎬 YouTube</a>
            <a href="https://www.twitch.tv/kabadayigames" target="_blank" rel="noopener noreferrer" className="social-button">👾 Twitch</a>
            <a href="https://buymeacoffee.com/resulcalisk" target="_blank" rel="noopener noreferrer" className="social-button">☕ Kahve Ismarla</a>
          </div>

          <p className="footer-copy">
            &copy; {new Date().getFullYear()} Kabadayı Games. Tüm hakları saklıdır. Handcrafted with heart.
          </p>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
